import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingDimensionInput')
export class ShippingDimension {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('sdim') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  height: number

  @Field(() => Float)
  @Prop({ type: Number })
  width: number

  @Field(() => Float)
  @Prop({ type: Number })
  length: number

  @Field(() => String)
  @Prop({ type: String })
  unit: string
}
